/** Small visitor map at the end of the home page (the site has no footer). */
import React, { useEffect, useRef } from 'react';

import * as styles from './homePage.module.less';

const VISITOR_MAP_SRC = [
  'https://mapmyvisitors.com/map.js?cl=ffffff&w=a&t=n',
  '&d=kSjXsVwrxvK-nD9lnu4jzabJKRSwpsNTQlJDNnAmDRA',
].join('');

/** Load the mapmyvisitors widget into its own box once the page mounts. */
const VisitorMap = () => {
  const visitorMapRef = useRef(null);

  useEffect(() => {
    const visitorMap = visitorMapRef.current;
    const script = window.document.createElement('script');

    script.id = 'mapmyvisitors';
    script.type = 'text/javascript';
    script.src = VISITOR_MAP_SRC;
    visitorMap.appendChild(script);

    return () => {
      visitorMap.textContent = '';
    };
  }, []);

  return (
    <div
      ref={visitorMapRef}
      className={styles.visitorMap}
      role="region"
      aria-label="Visitor map"
    />
  );
};

export default VisitorMap;
